import { render, staticRenderFns } from "./PendingBalanceStep.vue?vue&type=template&id=2e9591f8&scoped=true&lang=pug&"
import script from "./PendingBalanceStep.vue?vue&type=script&lang=js&"
export * from "./PendingBalanceStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9591f8",
  null
  
)

export default component.exports